import React, { useState, useEffect } from 'react';
import './Intro.css';
import logo from './assets/ddc-demo.png';
import animatingflag from './assets/WavingFlag.gif';

function Loading() {
  return (
    <div className="loading-overlay">
      <div className="loading-circle"></div>
    </div>
  );
}

function Intro() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulating a delay for the loading animation
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {isLoading && <Loading />}
      <div className={`intro-container ${isLoading ? 'loading' : ''}`}>
        <div className="text-container">
          <img src={logo} alt="Logo" className="logo" />
          <div className="text">
            <h1>सुदूरपश्चिम प्रदेश</h1>
            <p>शैक्षिक संस्थाहरूको भौगोलिक अवलोकन र इन्फोग्राफिक्स</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Intro;
